import React from 'react';
import Pagination from '@material-ui/lab/Pagination';
import { makeStyles, Typography } from '@material-ui/core';
import { PageSizeSelector } from '../PageSizeSelector';
import { PagePosition } from './PagePosition';
var useStyles = makeStyles(function () {
    return {
        root: {
            display: 'flex',
            padding: '10px',
            fontWeight: 400
        },
        paginationWrapper: {
            display: 'flex'
        },
        selectorLabel: {
            display: 'flex',
            marginLeft: '10px',
            alignItems: 'center'
        },
        selectorWrapper: {
            marginLeft: '16px'
        },
        spacer: {
            flex: 1
        }
    };
});
function PaginationBar(_a) {
    var paginationState = _a.paginationState, onChange = _a.onChange, onSizeChange = _a.onSizeChange;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement(Pagination, { className: classes.paginationWrapper, count: Math.ceil(paginationState.itemCount / paginationState.pageSize), page: paginationState.currentPage, onChange: onChange }),
        React.createElement(Typography, { variant: "body2", className: classes.selectorLabel }, "Rows per page:"),
        React.createElement("div", { className: classes.selectorWrapper },
            React.createElement(PageSizeSelector, { paginationState: paginationState, onChange: onSizeChange })),
        React.createElement("div", { className: classes.spacer }),
        React.createElement(PagePosition, { paginationState: paginationState })));
}
export default PaginationBar;
//# sourceMappingURL=PaginationBar.js.map